import Modal from "./Modal";
import { useShowModal } from "./use-modal";

export default Modal;

export {
  useShowModal,
};
